export const BANK_DETAILS_REQUEST_START: string = 'bankDetails/REQUEST_START';
export const BANK_DETAILS_REQUEST_FAIL: string = 'bankDetails/REQUEST_FAIL';
export const BANK_DETAILS_REQUEST_SUCCESS: string = 'bankDetails/REQUEST_SUCCESS';

export const RETRIEVE_BANK_DETAILS_REQUEST_START: string = 'bankDetails/retrieve/REQUEST_START';
export const RETRIEVE_BANK_DETAILS_REQUEST_FAIL: string = 'bankDetails/retrieve/REQUEST_FAIL';
export const RETRIEVE_BANK_DETAILS_REQUEST_SUCCESS: string = 'bankDetails/retrieve/REQUEST_SUCCESS';
export const RESET_RETRIEVE_BANK_DETAILS: string = 'bankDetails/reset/retrieve/REQUEST_SUCCESS';

export const CREATE_BANK_DETAILS_REQUEST_START: string = 'bankDetails/create/REQUEST_START';
export const CREATE_BANK_DETAILS_REQUEST_FAIL: string = 'bankDetails/create/REQUEST_FAIL';
export const CREATE_BANK_DETAILS_REQUEST_SUCCESS: string = 'bankDetails/create/REQUEST_SUCCESS';
export const RESET_CREATE_BANK_DETAILS: string = 'bankDetails/reset/REQUEST_SUCCESS';

export const GET_ALL_COUNTRY_DETAILS_REQUEST_START: string = 'countryDetails/get/REQUEST_START';
export const GET_ALL_COUNTRY_DETAILS_REQUEST_FAIL: string = 'countryDetails/get/REQUEST_FAIL';
export const GET_ALL_COUNTRY_DETAILS_REQUEST_SUCCESS: string = 'countryDetails/get/REQUEST_SUCCESS';

export const GET_ALL_CURRENCY_DETAILS_REQUEST_START: string = 'currencyDetails/get/REQUEST_START';
export const GET_ALL_CURRENCY_DETAILS_REQUEST_FAIL: string = 'currencyDetails/get/REQUEST_FAIL';
export const GET_ALL_CURRENCY_DETAILS_REQUEST_SUCCESS: string = 'currencyDetails/get/REQUEST_SUCCESS';

export const BANK_DETAILS_V2_REQUEST_START: string = 'bankDetailsV2/REQUEST_START';
export const BANK_DETAILS_V2_REQUEST_FAIL: string = 'bankDetailsV2/REQUEST_FAIL';
export const BANK_DETAILS_V2_REQUEST_SUCCESS: string = 'bankDetailsV2/REQUEST_SUCCESS';

export const DELETE_BANK_DETAILS_REQUEST_START: string = 'bankDetailsV2/DELETE/REQUEST_START';
export const DELETE_BANK_DETAILS_REQUEST_FAIL: string = 'bankDetailsV2/DELETE/REQUEST_FAIL';
export const DELETE_BANK_DETAILS_REQUEST_SUCCESS: string = 'bankDetailsV2/DELETE/REQUEST_SUCCESS';
export const RESET_DELETE_BANK_DETAILS: string = 'bankDetailsV2/reset/REQUEST_SUCCESS';

export const ADD_BANK_DETAILS_DOCUMENT_REQUEST_START: string = 'bankDetailsDocument/Add/REQUEST_START';
export const ADD_BANK_DETAILS_DOCUMENT_REQUEST_FAIL: string = 'bankDetailsDocument/Add/REQUEST_FAIL';
export const ADD_BANK_DETAILS_DOCUMENT_REQUEST_SUCCESS: string = 'bankDetailsDocument/Add/REQUEST_SUCCESS';
export const RESET_ADD_BANK_DOCUMENT_DETAILS: string = 'bankDetailsDocument/reset/REQUEST_SUCCESS';

export const FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_START: string = 'organizationBankDetails/fetch/REQUEST_START';
export const FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_FAIL: string = 'organizationBankDetails/fetch/REQUEST_FAIL';
export const FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_SUCCESS: string = 'organizationBankDetails/fetch/REQUEST_SUCCESS';